<template>
  <div class="orders-ds eh-ds">
    <!-- <vue-simple-context-menu
      element-id="myUniqueId"
      :options="getOptions(currentStatus)"
      ref="vueSimpleContextMenu"
      @option-clicked="optionClicked"
      @menu-closed="currentStatus = null"
    /> -->

    <!-- <div class="orderGrid">
      <div class="order-grid col-sm-12 col-md-9 col-lg-9">
        <div class="header">
          <h1 class="title">Orders</h1>
        </div>
        <div class="columntop">
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
            <span id="col0" class="coltext">Medication/Procedure</span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col1" class="coltext">Order Post Date</span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col2" class="coltext">Order Post Time</span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
            <span id="col2" class="coltext">Order Description</span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col0" class="coltext">Status</span>
          </div>
          <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
            <span id="col0" class="coltext">Writer</span>
          </div>
        </div>
        <template v-if="orders">
          <div
            v-for="order in orders.slice().reverse()"
            :key="'order' + order.orderid"
            :class="'columnrow ' + order.status"
            @contextmenu.prevent.stop="changeStatus($event, order)"
            @click="showOrder(order)"
          >
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
              <span id="row" class="coltext">
                <ul>
                  <li
                    v-for="(med, index) in orderItems[order.orderid]['medications']"
                    :key="order.orderid + 'med' + index"
                  >
                    {{ med.medname }}
                  </li>
                  <li
                    v-for="(proc, index) in orderItems[order.orderid]['procedures']"
                    :key="order.orderid + 'proc' + index"
                  >
                    {{ proc.procedure_code }}
                  </li>
                </ul>
              </span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
              <span id="row" class="coltext">{{ order.orderdate }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
              <span id="row" class="coltext">{{ order.ordertime }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
              <span id="row" class="coltext">{{
                stripHTML(order.orderdescription)
              }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
              <span id="row" class="coltext">{{ order.status }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
              <span id="row" class="coltext">{{ order.primary_physician }}</span>
            </div>
          </div>
        </template>
      </div>
    </div> -->
    <div class="container">
      <div v-if="!isMobile()" class="header2">
        <h2 class="title">Orders</h2>
        <button type="button" title="Create New Order" @click="showAddOrder">
          <font-awesome-icon :icon="['fas', 'plus-circle']" />
        </button>
      </div>
      <template v-else>
        <div class="header-mobile">
          ORDERS
          <button type="button" title="Create New Order" @click="showAddOrder">
            <font-awesome-icon :icon="['fas', 'plus-circle']" />
          </button>
        </div>
        <div class="nav-links mobile">
            <div :class="ordersFilter === 'new' ? 'current-tab' : ''" @click="ordersFilter = 'new'">New</div>
            <div :class="ordersFilter === 'procedures' ? 'current-tab' : ''" @click="ordersFilter = 'procedures'">Procedures</div>
            <div :class="ordersFilter === 'medications' ? 'current-tab' : ''" @click="ordersFilter = 'medications'">Medications</div>
            <div :class="ordersFilter === 'all' ? 'current-tab' : ''" @click="ordersFilter = 'all'">All</div>
        </div>
        <button v-if="ordersFilter == 'new'" class="signAllBtn" @click="signAllOrders">Sign All New Orders</button>
      </template>
      <table v-if="!isMobile()">
        <thead>
          <tr>
            <th>Medication/Procedure</th>
            <th>Order Post Date</th>
            <th>Order Post Time</th>
            <th>Order Description</th>
            <th>Status</th>
            <th>Nurse</th>
            <th>Physician</th>
          </tr>
        </thead>
        <tbody v-if="orders">
          <!-- <tr
            v-for="order in filterOrders().slice()"
            :key="'order' + order.orderid"
            :class="`status-${order.status}`"
            @contextmenu.prevent.stop="changeStatus($event, order)"     <---- commented out to stop using this
            @click="showOrder(order)"
          > -->
          <tr
            v-for="order in orders.sort(function(a, b) {
              return (b.orderdate+b.ordertime).localeCompare(a.orderdate+a.ordertime)
            })"
            :key="'order' + order.orderid"
          >
            <td v-if="order.status !== 'discontinue'" data-label="Medications/Procedures" class="medprocrow">
              <!-- Show medication if available -->
              <template v-if="order.medication || order.med_medentryid">
                <a 
                  href="#" 
                  class="order-link" 
                  @click.prevent="showOrder(order)"
                >{{ order.medication || order.med_medname || 'Medication' }}</a>
                <div v-if="order.med_amount || order.med_frequency || order.med_doseuom" class="med-details">
                  <span v-if="order.med_amount">Qty: {{ order.med_amount }}</span>
                  <span v-if="order.med_doseuom">Form: {{ order.med_doseuom }}</span>
                  <span v-if="order.med_frequency">Freq: {{ order.med_frequency }}</span>
                </div>
              </template>
              <!-- Show procedure(s) if no medication but procedures exist -->
              <template v-else-if="orderItems[order.orderid] && orderItems[order.orderid].procedures && orderItems[order.orderid].procedures.length > 0">
                <a 
                  href="#" 
                  class="order-link" 
                  @click.prevent="showOrder(order)"
                >{{ orderItems[order.orderid].procedures[0].procedure_code || orderItems[order.orderid].procedures[0].procShorthand || 'Procedure' }}</a>
                <div v-if="orderItems[order.orderid].procedures.length > 1" class="med-details">
                  <span>{{ orderItems[order.orderid].procedures.length }} procedures</span>
                </div>
                <div v-if="orderItems[order.orderid].procedures[0].diagnosis_code" class="med-details">
                  <span>Diagnosis: {{ orderItems[order.orderid].procedures[0].diagnosis_code }}</span>
                </div>
                <div v-if="orderItems[order.orderid].procedures[0].diagnosis_date" class="med-details">
                  <span>Date: {{ orderItems[order.orderid].procedures[0].diagnosis_date }}</span>
                </div>
              </template>
              <!-- Fallback if neither medication nor procedure data available yet -->
              <template v-else>
                <a 
                  href="#" 
                  class="order-link" 
                  @click.prevent="showOrder(order)"
                >{{ order.orderdescription ? stripHTML(order.orderdescription.substring(0, 50)) : 'Order #' + order.ordernumber }}</a>
              </template>
            </td>
            <td v-else data-label="Medications/Procedures" class="medprocrow">
              <!-- Show medication if available -->
              <template v-if="order.medication || order.med_medentryid">
                {{ order.medication || order.med_medname || 'Medication' }}
                <div v-if="order.med_amount || order.med_frequency || order.med_doseuom" class="med-details">
                  <span v-if="order.med_amount">Qty: {{ order.med_amount }}</span>
                  <span v-if="order.med_doseuom">Form: {{ order.med_doseuom }}</span>
                  <span v-if="order.med_frequency">Freq: {{ order.med_frequency }}</span>
                </div>
              </template>
              <!-- Show procedure(s) if no medication but procedures exist -->
              <template v-else-if="orderItems[order.orderid] && orderItems[order.orderid].procedures && orderItems[order.orderid].procedures.length > 0">
                {{ orderItems[order.orderid].procedures[0].procedure_code || orderItems[order.orderid].procedures[0].procShorthand || 'Procedure' }}
                <div v-if="orderItems[order.orderid].procedures.length > 1" class="med-details">
                  <span>{{ orderItems[order.orderid].procedures.length }} procedures</span>
                </div>
                <div v-if="orderItems[order.orderid].procedures[0].diagnosis_code" class="med-details">
                  <span>Diagnosis: {{ orderItems[order.orderid].procedures[0].diagnosis_code }}</span>
                </div>
                <div v-if="orderItems[order.orderid].procedures[0].diagnosis_date" class="med-details">
                  <span>Date: {{ orderItems[order.orderid].procedures[0].diagnosis_date }}</span>
                </div>
              </template>
              <!-- Fallback -->
              <template v-else>
                {{ order.orderdescription ? stripHTML(order.orderdescription.substring(0, 50)) : 'Order #' + order.ordernumber }}
              </template>
            </td>
            <td data-label="Order Post Date">{{ order.orderdate }}</td>
            <td data-label="Order Post Time">{{ order.ordertime }}</td>
            <td data-label="Order Description" class="descrow">
              {{ stripHTML(order.orderdescription) }}
            </td>
            <td data-label="Status">
              <span :class="`status-badge status-${order.status}`">{{ order.status }}</span>
            </td>
            <td data-label="Nurse" style="position: relative; vertical-align: middle;">
              <span v-if="order.ordernumber && order.ordernumber !== 0 && (!order.nursesignature || order.nursesignature === '') && order.providersignature && order.providersignature !== ''" 
                    class="sig-card" 
                    @click="openOrderModal(order)">
                <div class="signature-badge" role="img" aria-label="Nurse signature required">
                  <span class="sig-text">Nurse<br>Signature</span>
                  <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                    <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                    </g> 
                  </svg>
                </div>
              </span>
              <span v-else>{{ (order.ordernumber && order.ordernumber !== 0) ? (order.nursesignature || '') : 'N/A' }}</span>
            </td>
            <td data-label="Physician" style="position: relative; vertical-align: middle;">
              <span v-if="order.ordernumber && order.ordernumber !== 0 && order.nursesignature && order.nursesignature !== '' && (!order.providersignature || order.providersignature === '')" 
                    class="sig-card" 
                    @click="openOrderModal(order)">
                <div class="signature-badge" role="img" aria-label="Provider signature required">
                  <span class="sig-text">Provider<br>Signature</span>
                  <svg class="pen" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" style="transform: scaleX(-1); transform-origin: center;"> 
                    <g transform="translate(24,0) scale(-1,1)"> <path fill="white" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/> 
                    </g> 
                  </svg>
                </div>
              </span>
              <span v-else>{{ (order.ordernumber && order.ordernumber !== 0) ? (order.providersignature || '') : 'N/A' }}</span>
            </td>
          </tr>
          <!-- Add more rows as needed -->
        </tbody>
      </table>
      <template v-else>
        <div v-if="orders" class="table-container">
          <div class="accordion">
            <div
              v-for="order in orders"
              :key="'order' + order.orderid"
              :id="'order' + order.orderid"
              class="accordion-item"
              @click="showOrderDropdown(order.orderid)"
            >
              <button class="accordion-button">
                <div v-if="ordersFilter == 'medications'"
                :key="order.orderid + 'med'" :id="order.orderid + 'med'">
                  {{ order.orderdescription ? stripHTML(order.orderdescription.substring(0, 30)) : 'Order #' + order.ordernumber }}
                </div>
                <div v-if="ordersFilter == 'procedures'"
                :key="order.orderid + 'proc'" :id="order.orderid + 'med'">
                  {{ order.orderdescription ? stripHTML(order.orderdescription.substring(0, 30)) : 'Order #' + order.ordernumber }}
                </div>
                <div v-else>
                  {{ order.orderdescription ? stripHTML(order.orderdescription.substring(0, 30)) : 'Order #' + order.ordernumber }}
                </div>
              </button>
              <div class="accordion-content">
                <p><b>Order Date: </b>{{ `${order.orderdate}` }}</p>
                <p><b>Order Time: </b>{{ `${order.ordertime}` }}</p>
                <p><b>Order Type: </b>{{ `${order.ordertype}` }}</p>
                <p><b>Primary Physician: </b>{{ `${order.primary_physician}` }}</p>
                <p v-if="order.sec_physician"><b>Secondary Physician: </b>{{ `${order.sec_physician}` }}</p>
                <p><b>Phone: </b>{{ `${order.phone}` }}</p>
                <p v-if="order.fax"><b>Fax: </b>{{ `${order.fax}` }}</p>
                <div v-if="order.orderdescription"><b>Description: </b><p v-html="order.orderdescription"></p></div>
                <p><b>Status: </b><span :class="`status-badge status-${order.status}`">{{ `${order.status}` }}</span></p>
                <p v-if="order.writer"><b>Creator: </b>{{ `${order.writer}` }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div v-if="showNewOrderPopup && orderPopupPatient" class="orders-new-order">
      <order-popup
        class="order__popup"
        :patient="orderPopupPatient"
        :orderNum="orderNum"
        :id="'order__popup' + orderPopupPatient.patient_id"
        @close="handleOrderPopupClose"
      />
    </div>
    <div
      v-if="currentOrder"
      class="order-popup-overlay"
      @click.self="closeOrder"
    >
      <div class="msorderwrapper order-popup-content" id="order__popup">
      <div class="order-wrapper col-sm-12 col-lg-12">
        <div class="container">
          <div class="col-sm-12 col-lg-12 opclosesec">
            <span id="closeOrdermod"
              >Order ID #{{ currentOrder.orderid }} For:
              <b
                >{{ patient.firstName + " " + patient.lastName }} ({{ patient.dob }})</b
              ></span
            >
            <h4></h4>
          </div>
          <form :id="'orderform' + patient.id">
            <div class="firstrow col-sm-12">
              <div class="col-sm-12 col-md-2 col-lg-2">
                <label for="orderdate" role="text">* Order Date</label>
                <input
                  type="date"
                  required
                  id="orderdate"
                  class="datefield"
                  name="date"
                  :value="currentOrder.orderdate"
                  disabled
                />
              </div>
              <div class="col-sm-12 col-md-2 col-lg-2">
                <label for="orderdate" role="text">* Order Time</label><br />
                <input
                  type="time"
                  required
                  id="ordertime"
                  class="timefield"
                  name="time"
                  :value="currentOrder.ordertime"
                  disabled
                />
              </div>
              <div class="col-sm-12 col-md-3 col-lg-3">
                <label for="ordertype" role="text">* Order Type</label><br />
                <select
                  required
                  id="ordertype"
                  class="ordertype"
                  name="ordertype"
                  v-model="currentOrder.ordertype"
                  disabled
                >
                  <option value="Physicians Order">Physicians Order</option>
                  <option value="Nurses Order">Nurses Order</option>
                </select>
              </div>
              <div class="col-sm-12 col-md-2 col-lg-2">
                <label for="abndelivered" role="text"> ABN Delivered?</label>
                <select
                  required
                  id="abntopatient"
                  class="abntopatient"
                  name="abn"
                  v-model="currentOrder.abndelivery"
                  disabled
                >
                  <option selected value="0">N/A</option>
                  <option value="1">Don't Know</option>
                  <option value="2">Let's Try</option>
                </select>
              </div>
              <div class="col-sm-12 col-md-2 col-lg-2">
                <label for="phyAgentphy" role="text">
                  Order Read Back To<br />Physican/Agent Of Physican</label
                >
                <select
                  required
                  name="phyAgent"
                  id="phyAgentphy"
                  class="phyAgentphy"
                  v-model="currentOrder.readorderback"
                  disabled
                >
                  <option selected value="NA">N/A</option>
                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 secondrow">
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label for="primphysician" role="text">* Primary Physican</label><br />
                <input
                  name="primphysician"
                  type="text"
                  required
                  placeholder=""
                  id="primphysician"
                  style="z-index: 9000; position: relative"
                  class="primphyfield"
                  :value="currentOrder.primary_physician"
                  disabled
                />
              </div>
              <!-- <div class="col-sm-12 col-md-4 col-lg-4">
                <label for="secphysician" role="text"> Secondary Physicians</label><br />
                <input
                  name="secphysician"
                  type="text"
                  id="secphysician"
                  class="secphysician"
                  :value="currentOrder.sec_physician"
                  disabled
                />
              </div> -->
              <div class="col-sm-12 col-md-4 col-lg-4">
                <label for="email" role="text">E-mail</label><br />
                <input
                  name="email"
                  type="text"
                  id="email"
                  class="email"
                  :value="currentOrder.email"
                  disabled
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 thirdrow">
              <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="npinumber" role="text">* NPI Number</label><br />
                <input
                  name="npinumber"
                  type="text"
                  required
                  id="npinumber"
                  class="npifield"
                  disabled
                  :value="currentOrder.npinumber"
                />
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="physaddress" role="text">* Address</label><br />
                <input
                  name="address"
                  type="text"
                  required
                  id="physaddress"
                  class="physaddressclass"
                  :value="currentOrder.address"
                  disabled
                />
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="orderphonenumber" role="text">Order Phone Number</label><br />
                <input
                  name="orderphone"
                  type="tel"
                  id="orderphonenumber"
                  class="orderphoneclass"
                  :value="currentOrder.phone"
                  disabled
                />
              </div>
              <div class="col-sm-12 col-md-4 col-lg-3">
                <label for="orderfaxnumber" role="text">Order Fax Number</label><br />
                <input
                  name="orderfax"
                  type="tel"
                  id="orderfaxnumber"
                  class="orderfaxclass"
                  disabled
                  :value="currentOrder.fax"
                />
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 forthfrow">
              <div class="col-sm-12 col-md-6 col-lg-6 orderaction">
                <label>
                  <input
                    type="checkbox"
                    id="sendtophysician"
                    name="sendtophysician"
                    value="Send To Physician"
                    v-model="currentOrder.sendtophys"
                    disabled
                  />Send To Physicians</label
                >
                <label>
                  <input
                    type="checkbox"
                    name="woundcareorder"
                    id="woundcare"
                    value="Wound Care Order"
                    v-model="currentOrder.woundcare"
                    disabled
                  />Wound Care Order</label
                ><br />
              </div>
            </div> -->
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="tabs col-sm-12 col-md-12 col-lg-12">
                <div class="ordescriptab" :class="activeTab == 0 ? 'active' : ''">
                  <a
                    href="#orderscript"
                    id="ordescripbtn"
                    title="Order Description"
                    @click.prevent="activeTab = 0"
                    >Order Description</a
                  >
                </div>
                <div
                  v-if="currentOrder && currentOrder.procOrMed !== 'procedure'"
                  class="medicationtab"
                  :class="activeTab == 1 ? 'active' : ''"
                  :style="{ display: 'block' }"
                >
                  <a
                    href="#medtab"
                    id="medicationbtn"
                    title="Medications Tab"
                    @click.prevent="activeTab = 1"
                    >Medications</a
                  >
                </div>
                <!-- <div
                  class="diagnosistab"
                  :class="activeTab == 2 ? 'active' : ''"
                  :style="{ display: 'block' }"
                >
                  <a
                    href="#diagnosistab"
                    id="diagnosisbtn"
                    title="Diagnosis Tab"
                    @click.prevent="activeTab = 2"
                    >Diagnosis</a
                  >
                </div> -->
                <div
                  v-if="currentOrder && currentOrder.procOrMed !== 'medication'"
                  class="proctab"
                  :class="activeTab == 3 ? 'active' : ''"
                  :style="{ display: 'block' }"
                >
                  <a
                    href="#proctab"
                    id="procbtn"
                    title="Procedure Tab"
                    @click.prevent="activeTab = 3"
                    >Procedure</a
                  >
                </div>
              </div>
            </div>
            <div
              id="ordercanvas"
              :style="[activeTab == 0 ? { display: 'block' } : { display: 'none' }]"
            >
              <EditorComponent
                v-model="currentOrder.orderdescription"
                editorStyle="height: 300px"
                readonly
              >
                <template #toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                  </span>
                </template>
              </EditorComponent>
              <br />
            </div>
            <div
              id="medicationcanvas"
              :style="[activeTab == 1 ? { display: 'block' } : { display: 'none' }]"
            >
              <div class="divider"></div>
              <div
                class="mediationmodal col-sm-12 col-md-12 col-lg-12"
                :id="'mediationmodal' + patient.id"
              >
                <div class="modaltop">
                  <section class="patienttopinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientname">
                      <p id="pname">{{ patient.firstName + " " + patient.lastName }}</p>
                    </div>
                    <div class="allergysec">
                      <span>Allergies</span><br />
                      <p></p>
                    </div>
                  </section>
                  <section class="patientsecondinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientbday">
                      <p id="pday">{{ patient.dob }}</p>
                    </div>
                    <div class="attendphysician"></div>
                  </section>
                </div>
                <form :id="'dosesform' + patient.id" @submit.prevent="updateMed">
                  <div class="mednamesec col-sm-12 col-lg-12">
                    <input
                      required
                      name="medsearchbox"
                      class="medsearchbox"
                      type="search"
                      :id="'medsearchbox' + patient.id"
                      placeholder="Search for Medications"
                      v-model="medicationSearchDescrip"
                      @keyup.prevent="showMedSearch"
                    />
                    <div
                      v-if="searchedMeds"
                      :class="'searchresult' + patient.id"
                      id="medsearchresult"
                    >
                      <div
                        v-for="med in searchedMeds"
                        class="medlist"
                        :key="med.rxcui"
                        @click="clickMed(med)"
                      >
                        <span id="rxcui">{{ med.rxcui }}</span>
                        <p>{{ med.name }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="modalbottom">
                    <div class="medfirstSec col-sm-12 col-md-4 col-lg-4">
                      <div class="flex-row">
                        <select id="freqselect" name="freq" required>
                          <option selected="selected" value="Frequency">
                            Frequency *
                          </option>
                          <option value="1 Times Daily">1 Times Daily</option>
                          <option value="1 Times Weekly">1 Times Weekly</option>
                          <option value="2 Times Daily">2 Times Daily</option>
                          <option value="2 Times Weekly">2 Times Weekly</option>
                          <option value="3 Times Daily">3 Times Daily</option>
                          <option value="3 Times Weekly">3 Times Weekly</option>
                        </select>
                        <label
                          ><input
                            name="PRN"
                            type="checkbox"
                            :id="'prncheckbox' + patient.id"
                            value="PRN"
                          />
                          PRN</label
                        >
                      </div>
                      <div class="flex-row">
                        <input
                          required
                          type="text"
                          placeholder="Reason *"
                          name="reason"
                          id="medReason"
                          v-model="diagSearchDescrip"
                          @keyup.prevent="showDiagSearch"
                        />
                        <div
                          v-if="searchedDiags && searchedDiags.length != 0"
                          class="medDiagSearch"
                        >
                          <div
                            v-for="diag in searchedDiags"
                            class="medIcdli"
                            :key="diag.code"
                            @click="clickDiag(diag)"
                          >
                            <span id="icdcode">{{ diag.code }}</span> -
                            <span id="icddesript">{{ diag.description }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="flex-row">
                        <input
                          type="text"
                          placeholder="Route"
                          name="route"
                          id="medRoute"
                        />
                      </div>
                      <div class="flex-row">
                        <select id="altrouteselect" name="altroute" required>
                          <option selected="selected" value="Frequency">
                            Alternative Route*
                          </option>
                          <option value="1 daily">By Mouth</option>
                          <option value="2 daily">By Mouth Under Toungue</option>
                          <option value="3 daily">Cheek of Mouth</option>
                          <option value="2">Each Ear</option>
                          <option value="2">Each Eye</option>
                        </select>
                      </div>
                      <div class="flex-row">
                        <input
                          type="text"
                          placeholder="Instruction"
                          name="instructions"
                          id="medInstructions"
                        />
                      </div>
                    </div>
                    <div class="medsecondSec col-sm-12 col-md-4 col-lg-4">
                      <div class="flex-row medLabelGroup">
                        <label class="medDateLabel">Start Date *</label
                        ><label class="medDateLabel">End Date *</label>
                      </div>
                      <div class="flex-row">
                        <input type="date" id="medStartdate" name="startDate" required />
                        <input type="date" id="Medenddate" name="endDate" required />
                      </div>
                      <div class="flex-row">
                        <select id="neworchange" name="neworchange">
                          <option selected="selected" value="Dose UOM">New/Change</option>
                          <option value="New">New</option>
                          <option value="Change">Change</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div class="flex-column">
                        <input
                          type="text"
                          id="drugcategory"
                          name="drug"
                          placeholder="Drug Classification"
                        />
                      </div>
                    </div>
                    <div class="medthirdSec col-sm-12 col-md-4 col-lg-4">
                      <div class="flex-column medThirdCol">
                        <label>Medication Understanding</label>
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="meddirectionuse"
                          />Direction for Use</label
                        >
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="Medpurpose"
                          />Purpose</label
                        >
                        <label
                          ><input
                            type="radio"
                            id="MedSideffects"
                            name="understanding"
                          />Side Effects/Interactions</label
                        >
                        <label
                          ><input
                            name="understanding"
                            type="radio"
                            id="noUnder"
                          />None</label
                        >
                      </div>
                      <div class="flex-column medThirdCol">
                        <label>Additional Settings</label>
                        <label
                          ><input type="radio" id="agencyadmin" name="settings" />Agency
                          Administered</label
                        >
                        <label
                          ><input type="radio" id="highrisk" name="settings" />High
                          Risk</label
                        >
                        <label
                          ><input
                            type="radio"
                            id="noSettings"
                            name="settings"
                          />None</label
                        >
                      </div>
                      <div class="flex-column medThirdBtn">
                        <input type="submit" id="savemedbtn" value="Save" />
                        <input
                          type="button"
                          id="cancelmedbtn"
                          @click="closeMed"
                          value="Cancel"
                        />
                      </div>
                    </div>
                  </div>
                </form>
                <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                  <div class="sortgrid">
                    <label id="switchlbl">View Current Medications</label
                    ><label id="switch"
                      ><input type="checkbox" id="toggleSearch" />
                      <span class="slider round"></span
                    ></label>
                  </div>
                </div>
              </div>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop">
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                    <span id="col2" class="coltext">Medication</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col3" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Frequency</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Start</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col6" class="coltext">End</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Route</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col8" class="coltext">Alternative Route</span>
                  </div>
                </div>
                <template v-if="currentDetails && (currentDetails.medName || currentDetails.medname)">
                  <div
                    :key="'med' + (currentDetails.medId || currentDetails.medentryid || '')"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                      <span id="row" class="coltext">{{ currentDetails.medName || currentDetails.medname }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagDescription }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.frequency }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.startDate }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.endDate }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.route }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ currentDetails.altRoute }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- <div
              id="diagnosiscanvas"
              :style="[activeTab == 2 ? { display: 'block' } : { display: 'none' }]"
            >
              <div class="divider"></div>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-9 top-col">
                    <span id="col3" class="coltext">Diagnosis Code</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col4" class="coltext">Control System Rating</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col7" class="coltext">Date</span>
                  </div>
                </div>
                <template v-if="orderItems[currentOrder.orderid]['diagnosis']">
                  <div
                    v-for="(diag, index) in orderItems[currentOrder.orderid]['diagnosis']"
                    :key="'diag' + diag.diagnosis_code + index"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-9 top-row">
                      <span id="row" class="coltext">{{ diag.diagnosis_code }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{
                        diag.system_controlrating
                      }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ diag.diagnosis_date }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div> -->
            <!--Diagnosis Canvas below-->
            <div
              id="diagnosiscanvas"
              :style="[activeTab == 3 ? { display: 'block' } : { display: 'none' }]"
            >
              <div class="divider"></div>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-col">
                    <span id="col3" class="coltext">Procedure</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col4" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col4" class="coltext">Instruction</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col7" class="coltext">Date</span>
                  </div>
                </div>
                <template v-if="currentDetails && (currentDetails.code || currentDetails.procedure_code)">
                  <div
                    :key="'diag' + (currentDetails.procId || currentDetails.orddiagid || currentDetails.diagnosis_id || '')"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-6 top-row">
                      <span id="row" class="coltext">{{ currentDetails.procedure_code || currentDetails.procShorthand || currentDetails.code || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagnosis_code || currentDetails.diagDescription || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.instruction || currentDetails.instructions || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ currentDetails.diagnosis_date || currentDetails.startDate || '' }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!--ENd of Diagnosis Canvas -Quick Legend Location Finder-->
            <!--Add Signed Signature fields to verify Orders has been signed  KW 4/28/26-->
            <div class="col-sm-12 col-md-12 col-lg-12 sig-wrapper">
              <div class="provsig-wrapper">
                  <div class="provname-container">
                    <label>Provider Signature:</label>
                    <input
                      required
                      disabled='true'
                      class="satisfy-regular"
                      type="text"
                      id="provname"
                      v-model="finalProvSignature"
                     
                    
                    
                    />
                  </div>
                  <div class="provsigdate">
                    <label>Signature Date:</label
                    ><input
                      required
                      disabled="disabled"
                      type="date"
                      id="provdatefld"
                      v-model="provSigDate"
                    />
                    <!-- <input :disabled="ordstatus" :class="{ 'disabled-input': ordstatus }" type="text" id="provtimstmp" v-model="patient.provsigtimestamp" /> -->
                  </div>
                </div>
                <div class="nursig-wrapper">
                  <div class="nursename">
                    <label>Nurse Signature:</label>
                    <input
                      required
                      disabled="disabled"
                      class="satisfy-regular"
                      type="text"
                      v-model="finalNureSignature"
                      id="nursename"
                     
                    
                    />
                  </div>
                  <div class="nrssigdate">
                    <label>Signature Date:</label
                    ><input
                      required
                      disabled="disabled"
                      type="date"
                      v-model="nurseSigDate"
                      id="nursdatefld"
                    />
                    <!-- <input :disabled="ordstatus" :class="{ 'disabled-input': ordstatus }"  type="text" id="nrstimstmp" v-model="patient.nurssigtimestamp" /> -->
                  </div>
                </div>
            </div><!--sigWerapperend-->
            <div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
              <input
                type="button"
                value="Close"
                id="cancelbtn"
                class="cancelbtn"
                @click="closeOrder"
              />
            </div>
          </form>
        </div>
        </div>
      </div>
    </div>
    <MedadminshortOrderTemplate
      v-model:modelValue="showOrderModal"
      :order="selectedOrder"
      @submitsig="handleSubmit"
    />
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import { mapGetters, mapActions } from "vuex";
import { mapState } from "pinia";
import axios from "axios";
import $ from "jquery";
import MedadminshortOrderTemplate from './currents/MedadminshortOrderTemplate.vue'
import OrderPopup from "@/components/private-layouts/OrderPopup.vue";
import { usePrivilegesStore } from "@/stores/privileges";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";

export default {
  name: "OrdersPage",
  components: {
    MedadminshortOrderTemplate,
    "order-popup": OrderPopup,
  },
  data() {
    return {
      orders: null,
      orderItems: {},
      currentOrder: null,
      currentDetails: null,
      currentStatus: null,
      activeTab: 0, // Switch that focuses on right tab; 0 == order, 1 == medications, 2 == diagnosis, 3 == procedure
      // allMeds: null,
      // allDiags: null,
      allProcs: null, // All procedures for the patient (loaded once like CurrentProc.vue)
      diagSearchCode: "",
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch
      medicationSearchCode: "",
      medicationSearchDescrip: "", // Medication search description (textfield) value
      currentMedId: null,
      searchedMeds: [], // List of medications retrieved via medicationSearch
      ordersFilter: 'all',
      showOrderModal: false,
      selectedOrder: null,
      accounttype: '', // from GetAccountType — used with profflicense for the HomeGrid NPI-less admin gate
      profflicense: '', // professionalLicense.license; empty means no NPI on an Administrator
      finalNureSignature:'',
      finalProvSignature: '', //V-model value for Provider signature
      nurseSigDate:'', //Nurse Sig Date
      provSigDate:'', //PRovider Sig Date
      showNewOrderPopup: false,
      orderNum: null,
     
    };
  },
  async mounted() {
    await this.reloadOrderList();
    await this.getAccountType();
  },
  computed: {
    canOrderSign() {
      return usePrivilegesStore().effectiveGranted(PRIVILEGES.ORDER_SIGN);
    },
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    ...mapState(useSessionSelfStore, {
      sessionSelfProfile: "profile",
    }),
    patient: function () {
      return this.allData.patient;
    },
    // OrderPopup expects HomeGrid patient-row fields (patient_id, first_name, …).
    orderPopupPatient() {
      const p = this.patient;
      if (!p) return null;
      return {
        ...p,
        patient_id: p.patient_id || p.externId || p.id,
        accountnumber: p.accountnumber || p.externId2,
        first_name: p.first_name || p.firstName || "",
        lastname: p.lastname || p.lastName || "",
        date_of_birth: p.date_of_birth || p.dob || "",
      };
    },
  },
  methods: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    async showAddOrder() {
      if (
        !assertPrivilegeOrAlert(
          PRIVILEGES.ORDER_WRITE,
          "You do not have permission to write orders"
        )
      ) {
        return;
      }
      // Same gate as HomeGrid.showOrder: Administrators without an NPI must not open the
      // popup or consume a GetOrderNumber. accounttype/profflicense come from getAccountType.
      if (!this.accounttype) {
        await this.getAccountType();
      }
      if (this.accounttype === "Administrator" && this.profflicense === "") {
        alert(
          "Sorry, Administrators without an NPI can't write or assign Orders. Please ask the administrator to upgrade your permissions"
        );
        return;
      }
      if (!this.orderPopupPatient?.patient_id) {
        alert("No patient selected. Open a patient chart before writing an order.");
        return;
      }
      this.showNewOrderPopup = false;
      await this.$nextTick();
      this.showNewOrderPopup = true;
      let content = {
        systemData: {
          API_Meth: "GetOrderNumber",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let num = res.data.ordernumber;
          if (num && num != "") {
            this.orderNum = num;
          } else {
            alert(
              "Error generating order number. Contact an administrator before creating a new order."
            );
            this.showNewOrderPopup = false;
          }
        })
        .catch(() => {
          alert(
            "Error generating order number. Contact an administrator before creating a new order."
          );
          this.showNewOrderPopup = false;
        });
    },
    handleOrderPopupClose() {
      this.showNewOrderPopup = false;
      this.orderNum = null;
      this.reloadOrderList();
    },
    async reloadOrderList() {
      // allProcs is loaded once on mount; refresh it so a procedure created in the
      // new-order popup is present when filterProceduresByOrder runs after close.
      await this.loadAllProcedures();
      this.orderItems = {};
      const res = await this.getOrders();
      if (res) {
        res.forEach((order) => {
          if (!this.orderItems[order.orderid]) {
            this.orderItems[order.orderid] = {};
          }
          this.loadMeds(order.orderid);
          this.filterProceduresByOrder(order.orderid);
        });
      }
    },
    signAllOrders(){
      let content = {
        Orders: {
          API_Meth: "SignAllOrders",
          pid: this.patient.externId,
        }
      }
      // in progress
    },
    async getAccountType() {
      // Logged-in actor (not the chart patient): same GetAccountType HomeGrid uses for the NPI gate.
      const actor = sessionActorFrom(this.allData, this.sessionSelfProfile);
      if (!actor.accountnumber || !actor.unique_ID) {
        return;
      }
      const content = {
        Account: {
          API_Meth: "GetAccountType",
          accountnumber: actor.accountnumber,
          subaccountnumber: actor.unique_ID,
        },
      };
      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });
        if (res.data && res.data.providerAssignment) {
          this.accounttype = res.data.providerAssignment.accounttype || "";
          this.profflicense =
            (res.data.professionalLicense && res.data.professionalLicense.license) || "";
        }
      } catch (e) {
        console.error("OrdersPage getAccountType", e);
      }
    },
    findNurseSignatue(obj)
    {
        /*checking account type and then set both signature automatically (Current Logged In User =prov OR use 'ord' to pull in presigned sig)*/
        console.log("HEEELP TRYING TO GET CURRENT DETAILS FOR ORDER");
        console.log(obj);
       if(obj=="Registered Nurse")
       {
         console.log("Order Has The Data We need possibly");
         console.log(this.orders)
        // return this.finalNureSignature = this.prov.user_Fname + ' '+ this.prov.user_Lname;
       }
       if(obj=="Provider" || obj =="Physicians")
       {
        console.log("Order Has The Data We need possibly");
        console.log(this.orders)
        alert("Provider Baby");
        //return this.finalNureSignature = this.order.nursesignature;
       }
    },
    findProviderSignature(obj)
    {
      /*checking account type and then set both signature automatically (Current Logged In User =prov OR use 'ord' to pull in presigned sig)*/
      if(obj=="Provider" || obj =="Physicians")
       {
          return this.finalProvSignature = this.prov.user_Fname + ' '+ this.prov.user_Lname;
       }
       if(obj=="Registered Nurse")
       {
        
          return this.finalProvSignature = this.order.providersignature;
       }
    },
    filterOrders(){
      if (this.ordersFilter === 'all'){
        return this.orders
      }
      else if (this.ordersFilter === 'new'){
        let newOrders = this.orders.filter((order) => {
          return order.status === 'Pending'
        })
        return newOrders
      }
      else if (this.ordersFilter === 'procedures'){
        let newOrders = this.orders.filter((order) => {
          let orderid = order.orderid
          let assignments = this.orderItems[orderid]
          let procs = assignments.procedures
          return procs && procs.length > 0
        })
        return newOrders
      }
      else if (this.ordersFilter === 'medications'){
        let newOrders = this.orders.filter((order) => {
          let orderid = order.orderid
          let assignments = this.orderItems[orderid]
          let meds = assignments.medications
          return meds && meds.length > 0
        })
        return newOrders
      }
    },
    showOrderDropdown(id){
      let entry = document.getElementById(`order${id}`)
      entry.classList.toggle("active")
    },
    async updateMed() {
      let form = document.getElementById("dosesform" + this.patient.id);
      let content = {
        MedicationEdit: {
          API_Meth: "UpdateMedication",
          patientID: this.patient.externId,
          medentryid: this.currentMedId,
          ordernumber: this.currentOrder.orderid,
          medname: this.medicationSearchDescrip,
          doseamount: "", //form.elements['dosage'].value,
          doseUOM: "", //form.elements['UOM'].value,
          frequency: form.elements["freq"].value,
          diagcode: form.elements["reason"].value,
          medRoute: form.elements["route"].value,
          altroute: form.elements["altroute"].value,
          instruction: form.elements["instructions"].value,
          medstrtdt: form.elements["startDate"].value,
          medenddt: form.elements["endDate"].value,
          changetype: form.elements["neworchange"].value,
          durgclassification: form.elements["drug"].value,
          prn: document.getElementById("prncheckbox" + this.patient.id).value,
          directionuse: form.elements["understanding"].value,
          additionalsettings: form.elements["settings"].value,
          medstatus: "Active",
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data.msg && res.data.msg == "Updated") {
            this.medicationSearchCode = "";
            this.medicationSearchDescrip = "";
            this.diagSearchCode = "";
            this.diagSearchDescrip = "";
            this.currentMedId = null;
            this.loadMeds(this.currentOrder.orderid);
            alert("Medication successfully updated");
            document.getElementById("mediationmodal" + this.patient.id).style.display =
              "none";
            $("#mediationmodal" + this.patient.id).css("display", "none");
            // $(".modalbottom form").css("display","none");
            // $(".mednamesec").css("display","none");
            form.reset();
          } else {
            alert("Error with medication update. Try again or contact an administrator.");
          }
        });
    },
    showEditMed(med) {
      this.currentMedId = med.medentryid;
      $("#mediationmodal" + this.patient.id).css("display", "flex");
      $("form .modalbottom").css("display", "flex");
      $("#dosesform" + this.patient.id).css("display", "block");
      let form = document.getElementById("dosesform" + this.patient.id);
      this.medicationSearchDescrip = med.medname;
      this.diagSearchDescrip = med.diagnose_code;
      document.querySelector("#dosesform" + this.patient.id + " #medRoute").value =
        med.route;
      document.querySelector("#dosesform" + this.patient.id + " #altrouteselect").value =
        med.alt_route;
      document.querySelector("#dosesform" + this.patient.id + " #medStartdate").value =
        med.med_startdate;
      document.querySelector("#dosesform" + this.patient.id + " #freqselect").value =
        med.med_frequency;
      document.querySelector("#dosesform" + this.patient.id + " #medInstructions").value =
        med.instruction;
      document.querySelector("#dosesform" + this.patient.id + " #Medenddate").value =
        med.med_enddate;
    },
    async showMedSearch() {
      if (this.medicationSearchDescrip == "") {
        this.searchedMeds = [];
        return;
      }
      let posturl =
        "https://rxnav.nlm.nih.gov/REST/drugs.json?name=" + this.medicationSearchDescrip;
      await axios.get(posturl).then((res) => {
        if (res.data.drugGroup.conceptGroup) {
          for (let tty of res.data.drugGroup.conceptGroup) {
            if (tty.conceptProperties) {
              this.searchedMeds = this.searchedMeds.concat(tty.conceptProperties);
            }
          }
        } else {
          this.searchedMeds = [];
        }
      });
    },
    clickMed(med) {
      this.medicationSearchCode = med.rxcui;
      this.medicationSearchDescrip = med.name;
      this.searchedMeds = [];
    },
    async showDiagSearch() {
      if (this.diagSearchDescrip == "") {
        this.searchedDiags = [];
        return;
      }
      if (true) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            // console.log(res);
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
            }
          });
      }
    },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    closeMed() {
      let doses = document.getElementById("dosesform" + this.patient.id);
      doses.reset();
      doses.style.display = "none";
      let form = document.getElementById("mediationmodal" + this.patient.id);
      form.style.display = "none";
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.currentMedId = null;
    },
    // getOptions(status) {
    //   if (!status) return [];
    //   switch (status.split(" ")[0]) {
    //     case "Active":
    //       return [{ name: "Hold" }, { name: "Discontinue" }];
    //     case "Pending":
    //       return [{ name: "Activate" }, { name: "Discontinue" }];
    //     case "Hold":
    //       return [{ name: "Reactivate" }, { name: "Discontinue" }];
    //     case "Discontinued":
    //       return [{ name: "Reactivate" }];
    //     default:
    //       return [];
    //   }
    // },
    // changeStatus(event, item) {
    //   this.currentStatus = item.status;
    //   this.$refs.vueSimpleContextMenu.showMenu(event, item);
    // },
    // async optionClicked(event) {
    //   let order = event.item;
    //   let action = event.option.name;

    //   if (action === "Activate" || action === "Reactivate")
    //     action = "Active (signed by " + this.allData.manager.name + ")";
    //   else if (action === "Discontinue") action = "Discontinued";
    //   let content = {
    //     Orders: {
    //       API_Meth: "ChangeOrderStatus",
    //       ordernumber: order.orderid,
    //       status: action,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       // console.log(res)
    //       if (res.data.result && res.data.result === "Updated") {
    //         alert("Order status updated.");
    //         this.getOrders();
    //       } else {
    //         alert("Error in updating order.");
    //       }
    //     });
    // },
    async getOrders() {
      let content = {
        Orders: {
          API_Meth: "GetALLPatientOrdersWithMedications",
          patientID: this.patient.externId,
        },
      };
      let ret = null;
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.Count > 0) {
            ret = res.data.result;
            this.orders = ret;
            // Process medication data for orders that have it
            ret.forEach((order) => {
              if (!this.orderItems[order.orderid]) {
                this.orderItems[order.orderid] = {};
              }
              
              if (order.med_medentryid) {
                // Store medication data in orderItems for compatibility with existing code
                if (!this.orderItems[order.orderid].medications) {
                  this.orderItems[order.orderid].medications = [];
                }
                // Add medication object with mapped fields
                this.orderItems[order.orderid]['medications'].push({
                  medentryid: order.med_medentryid,
                  medname: order.med_medname,
                  med_amount: order.med_amount,
                  med_frequency: order.med_frequency,
                  route: order.med_route,
                  alt_route: order.med_alt_route,
                  diagnose_code: order.med_diagnose_code,
                  med_startdate: order.med_startdate,
                  med_enddate: order.med_enddate,
                  med_doseuom: order.med_doseuom,
                  instruction: order.med_instruction,
                  prn: order.med_prn,
                  ndcnumber: order.med_ndcnumber,
                  rxnorns: order.med_rxnorns,
                  total: order.med_total,
                  available: order.med_available,
                  additional_settings: order.med_additional_settings,
                  medchangetype: order.med_medchangetype,
                  status: order.med_status,
                  prepour: order.med_prepour,
                  nebulizer: order.med_nebulizer,
                  medadmin: order.med_medadmin
                });
              }
            });
          } else {
            this.orders = null;
          }
          console.log(res.data, this.orders)
        });
      return ret;
    },
    async getNewOrders() {
      let content = {
        API_Meth: "GetOrders",
        pid: this.patient.externId,
        accountId: this.patient.externId2
      }
      await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      })
      .then((res) => {
        if (res.data){
          this.orders = res.data
        }
        else
          this.orders = null
      })
    },
    async loadOrderDetails(order){
      // Check if medication data is already available from the order object
      if (order.med_medentryid) {
        // Use medication data directly from the order
        this.currentDetails = {
          medId: order.med_medentryid,
          medName: order.med_medname,
          medname: order.med_medname,
          dosage: order.med_amount,
          frequency: order.med_frequency,
          route: order.med_route,
          altRoute: order.med_alt_route,
          diagDescription: order.med_diagnose_code, // Use diagnose code
          startDate: order.med_startdate,
          endDate: order.med_enddate,
          unitType: order.med_doseuom,
          instructions: order.med_instruction,
          prn: order.med_prn,
          ndcnumber: order.med_ndcnumber,
          rxnorns: order.med_rxnorns,
          quantity: order.med_total,
          available: order.med_available,
          additional_settings: order.med_additional_settings,
          medchangetype: order.med_medchangetype,
          status: order.med_status,
          prepour: order.med_prepour,
          nebulizer: order.med_nebulizer,
          administration: order.med_medadmin
        };
        return;
      }
      
      // Check if procedure data is available in orderItems
      if (this.orderItems[order.orderid] && this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0) {
        // Use procedure data directly from orderItems
        const proc = this.orderItems[order.orderid].procedures[0];
        this.currentDetails = {
          procId: proc.orddiagid || proc.diagnosis_id || proc.diagid,
          code: proc.procedure_code || proc.procShorthand,
          procedure_code: proc.procedure_code,
          procShorthand: proc.procShorthand,
          diagDescription: proc.diagnosis_code,
          diagnosis_code: proc.diagnosis_code,
          instructions: proc.instruction,
          instruction: proc.instruction,
          startDate: proc.diagnosis_date,
          diagnosis_date: proc.diagnosis_date,
          endDate: proc.end_date,
          end_date: proc.end_date,
          writer: proc.writer
        };
        // Set active tab to procedure tab
        this.activeTab = 3;
        return;
      }
      
      // For orders table, check procOrMed field or determine type from order data
      let orderType = 'medication'; // default
      if (order.procOrMed === 'procedure') {
        orderType = 'procedure';
      } else if (this.orderItems[order.orderid] && this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0) {
        orderType = 'procedure';
      }
      
      let procOrMedId = null;
      if (this.orderItems[order.orderid] && this.orderItems[order.orderid].medications && this.orderItems[order.orderid].medications.length > 0) {
        procOrMedId = this.orderItems[order.orderid].medications[0].medentryid;
      } else if (this.orderItems[order.orderid] && this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0) {
        procOrMedId = this.orderItems[order.orderid].procedures[0].orddiagid || this.orderItems[order.orderid].procedures[0].diagnosis_id || this.orderItems[order.orderid].procedures[0].diagid;
      }
      
      let content = {
        API_Meth: "GetOrderDetails",
        type: orderType,
        id: procOrMedId,
        ordernumber: order.ordernumber,
        patientid: this.patient.externId
      }
      await axios.post(CURR_API + "/tswebhook.php", content, {
        headers: { "Content-Type": "application/json;" },
      })
      .then((res) => {
        if (res.data){
          console.log(res.data)
          this.currentDetails = res.data
        }
        else {
          this.currentDetails = null
        }
      })
    },
    async loadMeds(ordnum) {
      let content = {
        MedGrid: {
          API_Meth: "PopulateMedGridByOrderID",
          pid: this.patient.externId,
          ordernumber: ordnum,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (!this.orderItems[ordnum]) {
            this.orderItems[ordnum] = {};
          }
          
          if (res.data.gridhtml && res.data.data) {
            this.orderItems[ordnum].medications = res.data.data;
          } else {
            this.orderItems[ordnum].medications = null;
          }
        });
    },
    async loadAllProcedures() {
      // Use the same API call structure as CurrentProc.vue
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: this.patient.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // Use the same check as CurrentProc.vue (res.data.gridhtml)
          if (res.data && res.data.gridhtml && res.data.data && Array.isArray(res.data.data)) {
            // Store all procedures and diagnoses
            this.allProcs = res.data.data.filter(
              (proc) => proc.diagnosis_type === "Procedure"
            );
          } else {
            this.allProcs = null;
          }
        });
    },
    filterProceduresByOrder(ordnum) {
      // Filter procedures from allProcs by order_id
      if (!this.orderItems[ordnum]) {
        this.orderItems[ordnum] = {};
      }
      
      if (this.allProcs && Array.isArray(this.allProcs)) {
        // Try both order_id and orderid field names, and match with both string and number comparison
        let procs = this.allProcs.filter(
          (proc) => {
            const procOrderId = proc.order_id || proc.orderid || 0;
            return procOrderId == ordnum || procOrderId === ordnum || String(procOrderId) === String(ordnum);
          }
        );
        console.log(`Filtered procedures for order ${ordnum}:`, procs);
        this.orderItems[ordnum].procedures = procs.length > 0 ? procs : null;
      } else {
        this.orderItems[ordnum].procedures = null;
      }
    },
    async loadDiagsAndProcs(ordnum) {
      // This method is kept for backward compatibility but now uses filterProceduresByOrder
      this.filterProceduresByOrder(ordnum);
    },
    async showOrder(orderInfo) {
      this.currentOrder = orderInfo;
      console.log("SHOWWW ME THE MONEY- ORDER INDO");
      console.log(this.currentOrder);
      //Going to Set/Force Provider from Order Signature for Both Provider and Nurse (KW) -- And User Ordertype for fall back
      this.finalNureSignature = this.currentOrder.nursesignature; 
      this.finalProvSignature =this.currentOrder.primary_physician;
      //Setting Signature Dates
      this.provSigDate = this.currentOrder.providerdatesig;
      this.nurseSigDate = this.currentOrder.nursedatesig;
      // Ensure procedures are filtered for this order
      if (!this.orderItems[orderInfo.orderid] || !this.orderItems[orderInfo.orderid].procedures) {
        this.filterProceduresByOrder(orderInfo.orderid);
      }
      
      await this.loadOrderDetails(orderInfo)
      
      // Use procOrMed field to determine which tab to show
      if (orderInfo.procOrMed === 'medication') {
        this.activeTab = 1; // Medications tab
      } else if (orderInfo.procOrMed === 'procedure') {
        this.activeTab = 3; // Procedure tab
      } else {
        // Fallback: check if medication or procedure data exists
        if (orderInfo.med_medentryid || (this.orderItems[orderInfo.orderid] && this.orderItems[orderInfo.orderid].medications && this.orderItems[orderInfo.orderid].medications.length > 0)) {
          this.activeTab = 1;
        } else if (this.orderItems[orderInfo.orderid] && this.orderItems[orderInfo.orderid].procedures && this.orderItems[orderInfo.orderid].procedures.length > 0) {
          this.activeTab = 3;
        } else {
          this.activeTab = 0; // Order description
        }
      }
    },
    closeOrder() {
      let order = document.getElementById("order__popup");
      order.style.display = "none";
      this.currentOrder = null;
      this.allMeds = null;
      this.allDiags = null;
      this.allProcs = null;
    },
    stripHTML(html) {
      let text = new DOMParser().parseFromString(html, "text/html");
      return text.body.textContent || "";
    },
    getOrderItemId(order) {
      // Determine if this is a medication or procedure and get the appropriate ID
      if (order.procOrMed === 'medication' || order.med_medentryid) {
        // It's a medication
        if (order.med_medentryid) {
          return { itemId: order.med_medentryid, type: 'medication' };
        } else if (this.orderItems[order.orderid] && this.orderItems[order.orderid].medications && this.orderItems[order.orderid].medications.length > 0) {
          return { itemId: this.orderItems[order.orderid].medications[0].medentryid, type: 'medication' };
        }
      } else if (order.procOrMed === 'procedure' || (this.orderItems[order.orderid] && this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0)) {
        // It's a procedure
        if (this.orderItems[order.orderid] && this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0) {
          const proc = this.orderItems[order.orderid].procedures[0];
          return { itemId: proc.orddiagid || proc.diagnosis_id || proc.diagid, type: 'procedure' };
        }
      }
      // Fallback: try to determine from orderItems
      if (this.orderItems[order.orderid]) {
        if (this.orderItems[order.orderid].medications && this.orderItems[order.orderid].medications.length > 0) {
          return { itemId: this.orderItems[order.orderid].medications[0].medentryid, type: 'medication' };
        } else if (this.orderItems[order.orderid].procedures && this.orderItems[order.orderid].procedures.length > 0) {
          const proc = this.orderItems[order.orderid].procedures[0];
          return { itemId: proc.orddiagid || proc.diagnosis_id || proc.diagid, type: 'procedure' };
        }
      }
      return { itemId: null, type: 'medication' }; // Default fallback
    },
    async openOrderModal(order) {
      if (!this.canOrderSign) {
        alert("You do not have permission to sign off on orders.");
        return;
      }
      try {
        const { itemId, type } = this.getOrderItemId(order);
        if (!itemId) {
          alert("Unable to determine order item. Please try again.");
          return;
        }
        
        let content = {
          MedicationAdmin: {
            API_Meth: "LookupOrderInfoSigSignOff",
            accountnumber: this.allData.patient.externId2,
            npinumber: this.allData.manager.externid || '',
            patientid: this.allData.patient.externId,
            ordernumber: order.ordernumber,
            medentryid: itemId,
            provsubaccount: this.allData.manager.externid,
            type: type
          }
        };
        await axios.post(CURR_API + '/tswebhook.php', content)
          .then(response => {
            console.log(response.data);
            if (response.data && response.data.code == "200 Successfull" && response.data.results) {
              this.selectedOrder = response.data.results[0];
              console.log("Order LookUp Results");
              console.log(this.selectedOrder);
            }
          })
          .catch(error => {
            if (axios.isAxiosError(error)) {
              alert("Code:340 - System issue. Please contact system support");
              console.error('Error posting data:', error.response?.data || error.message);
            } else {
              alert("Oops, we hit an unexpected snag, please contact your system administrator if this error persists.");
              console.log('Unexpected error:', error);
            }
          });
        console.log("Order Id For the Order Template");
        console.log(order.ordernumber);
        console.log("Item ID For Order Template");
        console.log(itemId);
        console.log("Type For Order Template");
        console.log(type);
        this.showOrderModal = true;
      } catch (err) {
        console.error('Failed to load order', err);
      }
    },
    handleSubmit(nurseSignature) {
      console.log(nurseSignature);
     
      let content = {
        MedicationAdmin: {
          API_Meth: "UpdateOrderWithNurseSignature",
          accountnumber: this.allData.patient.externId2,
          patientid: this.allData.patient.externId,
          ordernumber: nurseSignature.ordernumber,
          nurseSignature: nurseSignature.nurseSignature,
          nurseSigDate: nurseSignature.nurseSignedDate,
          providerSignature: nurseSignature.provider,
          providerSignedDate: nurseSignature.providerSignedDate,
          action: nurseSignature.action,
          provsubaccount: this.allData.manager.externid
        }
      };
      axios.post(CURR_API + '/tswebhook.php', content)
        .then(response => {
          console.log(response.data);
          if (response.data && (response.data.code == "200 Successfull" || response.data.code =="200-Sql Success")) {
            alert("Signature updated successfully");
            this.getOrders();
            this.showOrderModal = false;
          } else {
            alert("Error updating signature. Please try again.");
          }
        })
        .catch(error => {
          if (axios.isAxiosError(error)) {
            alert("Code:340 - System issue. Please contact system support");
            console.error('Error posting data:', error.response?.data || error.message);
          } else {
            alert("Oops, we hit an unexpected snag, please contact your system administrator if this error persists.");
            console.log('Unexpected error:', error);
          }
        });
    },
  },
};
</script>

<style scoped>
/* @import "../../stylesheets/keyon"; */
.sig-wrapper{
  display:flex;
  flex-direction:column;      /* stack children vertically */
  align-items:flex-start;     /* left-align them */
  width:100%;
  gap:12px; 
}
.sig-wrapper input[type=text] {
    border-top-style: none;
    border-left-style: none;
    border-right-style: none;
    margin-left: 20px;
    width: 220px;
}
#nursename {
    margin-right: 15px;
    font-size: 25px;
}
.satisfy-regular {
    font-family: "Satisfy", serif;
    font-weight: 400;
    font-style: normal;
    font-size: 22px;
}
.nrssigdate {
    margin-left: 15px;
    margin-top: 10px;
}
.provsig-wrapper,
.nursig-wrapper{
  width:100%;
  display:flex;
  justify-content: flex-start; /* adjust as needed */
}
.provsigdate{
  margin-top: 20px;
  margin-left: 18px;
}
#provname {
   
    font-size: 25px;
    font-weight: 600;
}
.order-grid {
  margin: 0 auto;
}

.opclosesec {
  text-align: center;
}

/* .header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #0060ff;
} */

.header-mobile {
    text-align: center;
    padding: 10px 0;
    font-size: 1.5em;
    margin-top: 5%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
}

.header2 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.header2 button,
.header-mobile button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  font-size: 1.1em;
}

.orders-new-order :deep(.msorderwrapper) {
  position: fixed !important;
  text-align: center;
}

.title {
  margin-right: 20px;
}

.columnrow {
  background-color: unset;
}

ul {
  list-style-type: circle;
}

.ql-editor {
  font-size: 150%;
}

body {
  margin: 0;
  padding: 0;
}
.container {
  margin: 20px auto;
  overflow-x: auto;
}
@media only screen and (max-width: 576px){
  .container {
    text-align: center;
  }
}
h2 {
  text-align: center;
  margin: 0;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #d3d7db;
}
/* tr:nth-child(even) {
  background-color: #f2f2f2;
} */
.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 0.9em;
}
.button-container {
  text-align: center;
  margin: 20px 0;
}
.button-container button {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.button-container button:hover {
  opacity: 0.9;
}
@media (max-width: 768px) {
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }
  th {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }
  tr {
    margin: 0 0 1rem 0;
    border: 1px solid #d3d7db;
  }
  td {
    border: none;
    border-bottom: 1px solid #d3d7db;
    position: relative;
    padding-left: 50%;
    white-space: normal;
    text-align: left;
  }
  td:before {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    white-space: nowrap;
    content: attr(data-label);
    font-weight: bold;
  }
}

.medprocrow {
  width: 35%;
}

.descrow {
  width: 15%;
}

.nav-links {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;
}
.nav-links div {
    text-decoration: none;
    padding: 10px 20px;
    border-radius: 5px;
    margin: 5px 0;
    width: 80%;
    text-align: center;
}
.current-tab {
  pointer-events: none;
}
.accordion {
  margin-top: 10px;
}

.accordion-item {
  border-bottom: 1px solid #d3d7db;
}

.accordion-button {
  padding: 15px;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.accordion-content {
  display: none;
  padding: 15px;
  text-align: left;
}

.accordion-item.active .accordion-content {
  display: block; /* Show content when item is active */
}

.signAllBtn {
  margin-top: 4%;
  border-radius: 50px;
}

/* Order medication/procedure name link */
.order-link {
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}

.order-link:hover {
  text-decoration: none;
}

.med-details {
  font-size: 0.85em;
  font-style: italic;
  margin-top: 4px;
  line-height: 1.3;
}

.med-details span {
  margin-right: 8px;
}

.med-details span:last-child {
  margin-right: 0;
}

.order-popup-overlay {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex !important;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.order-popup-overlay .msorderwrapper {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  transform: none !important;
  margin: 0 !important;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
  border-radius: 9px;
  padding: 25px;
}

/* Signature Badge Styles - Matching CurrentProc.vue and CurrentMed.vue */
.sig-card {
  position: relative;
  display: inline-block;
  padding: 0px;
  border-radius: 8px;
  width: 75px;
  height: 0px;
  margin: 0px;
  /* Below sticky #navigation-bar (z-index: 100 in PrivateLayout). */
  z-index: 1;
  overflow: visible;
  cursor: pointer;
  vertical-align: middle;
  top: 0;
}

.signature-badge {
  position: absolute;
  top: 0;
  right: -26px;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px 10px 22px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;
  white-space: nowrap;
  pointer-events: auto;
  margin-top: 0;
}

.signature-badge::before {
  content: "";
  position: absolute;
  left: -18px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 12px solid transparent;
  border-bottom: 12px solid transparent;
  border-right: 18px solid #cb5f50;
  z-index: -1;
}

.signature-badge .pen {
  flex: 0 0 auto;
  margin-left: 2px;
  opacity: 0.95;
}

.sig-text {
  display: inline-block;
  text-align: left;
}

@media (max-width: 420px) {
  .signature-badge {
    font-size: 11px;
    padding: 8px 12px 8px 18px;
    right: -20px;
  }
  .signature-badge::before {
    left: -14px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 14px solid #cb5f50;
  }
}
</style>
